import "./sectionSubTitle.scss";

export const SectionSubTitle = ({ text }) => {
  return (
    <div className="section-subtitle">
      <h4>{text}</h4>
    </div>
  );
};
